import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAQklEQVR42pWOsQkAIAwEk9qpsqo2ruAeguA0vvBVVIIP1yQX8iIfUZCI3pYGGjEv7asMBuigcnYIk0LxQvgiLPnMAjLUCjGwV4okAAAAAElFTkSuQmCC"};
